import { useNavigate } from "react-router-dom";
import { APPS } from "@/Layouts/private/partials/AppSelector";
import { userStore } from "@/mobx/rootStore";

export function useAppNavigate() {
	const navigate = useNavigate();

	return (appName) => {
		const app = APPS.find((a) => a.appName === appName);
		if (!app?.route) return;

		userStore.lastApp = app.appName;
		navigate(app.route);
	};
}
